import React from 'react';
import { Box, Stack } from '@mui/material';
import { motion } from 'framer-motion';

import { formatEventWhen } from '../../utils/formatEventWhen';

// A single occurrence pulled from the shared Google Calendar (KBT-176).
// Deliberately simpler than EventDetailSection — these are informational
// calendar entries (no image, no ticketing/checkout), not the
// staff-created "Purchasable" events from the admin backend.
export default function CalendarEventRow({ event }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <Box
        sx={{
          py: 3,
          borderTop: '1px solid rgba(36,34,88,0.12)',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '220px 1fr' },
          gap: { xs: 1, sm: 3 },
        }}
      >
        <Box
          sx={{
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'var(--teal-500)',
          }}
        >
          {formatEventWhen(event)}
        </Box>

        <Stack spacing={0.5}>
          <Box
            sx={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: { xs: 20, md: 22 },
              color: 'var(--navy-500)',
              lineHeight: 1.2,
            }}
          >
            {event.title}
          </Box>
          {event.location && (
            <Box sx={{ fontFamily: 'var(--font-body)', fontSize: 13.5, color: 'var(--text-muted)' }}>
              {event.location}
            </Box>
          )}
          {event.description && (
            <Box sx={{ fontFamily: 'var(--font-body)', fontSize: 15, color: 'var(--text)', opacity: 0.85, mt: 0.5 }}>
              {event.description}
            </Box>
          )}
        </Stack>
      </Box>
    </motion.div>
  );
}
